"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SkillsWindow;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _SkillsWindowModule = _interopRequireDefault(require("./SkillsWindow.module.scss"));

var _WindowControls = _interopRequireDefault(require("../../WindowControls/WindowControls"));

var _Footer = _interopRequireDefault(require("./components/Footer/Footer"));

var _PageButtons = _interopRequireDefault(require("./components/PageButtons/PageButtons"));

var _Page = _interopRequireDefault(require("./components/Page/Page"));

var _TabButtons = _interopRequireDefault(require("./components/TabButtons/TabButtons"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function SkillsWindow(_ref) {
  var _ref$initialTab = _ref.initialTab,
      initialTab = _ref$initialTab === void 0 ? "CLASS" : _ref$initialTab,
      _ref$classSkills = _ref.classSkills,
      classSkills = _ref$classSkills === void 0 ? [] : _ref$classSkills,
      _ref$craftingSkills = _ref.craftingSkills,
      craftingSkills = _ref$craftingSkills === void 0 ? [] : _ref$craftingSkills,
      _ref$classSkillCombos = _ref.classSkillCombos,
      classSkillCombos = _ref$classSkillCombos === void 0 ? [] : _ref$classSkillCombos,
      _ref$skillPoints = _ref.skillPoints,
      skillPoints = _ref$skillPoints === void 0 ? 0 : _ref$skillPoints,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  var _useState = (0, _react.useState)(initialTab),
      _useState2 = _slicedToArray(_useState, 2),
      currentTab = _useState2[0],
      setCurrentTab = _useState2[1];

  var _useState3 = (0, _react.useState)(1),
      _useState4 = _slicedToArray(_useState3, 2),
      currentPage = _useState4[0],
      setCurrentPage = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = _slicedToArray(_useState5, 2),
      focusedPos = _useState6[0],
      setFocusedPos = _useState6[1];

  var entries = [];

  switch (currentTab) {
    case "CLASS":
      entries = classSkills.filter(function (skill) {
        return skill.windowPage === currentPage;
      });
      break;

    case "COMBOS":
      entries = classSkillCombos.filter(function (skillCombo) {
        return skillCombo.windowPage === currentPage;
      });
      break;

    case "CRAFTING":
      entries = craftingSkills;
      break;

    default:
      throw new Error("Unknown tab '".concat(JSON.stringify(currentTab), "'."));
  }

  var changeTab = (0, _react.useCallback)(function (tab) {
    setCurrentTab(tab);
    setCurrentPage(1);
    setFocusedPos(undefined);
  }, []);
  var changePage = (0, _react.useCallback)(function (page) {
    setCurrentPage(page);
    setFocusedPos(undefined);
  }, []);
  var handleOnClickEntry = (0, _react.useCallback)(function (x, y) {
    // TODO: if classSKill or craftingSkill then focus
    // TODO: if skill not isPassive start drag
    setFocusedPos({
      x: x,
      y: y
    });
  }, []);
  var handleOnClickSkillUp = (0, _react.useCallback)(function () {
    if (!focusedPos) return false;
    var skill = classSkills.find(function (entry) {
      return entry.windowPage === currentPage && entry.windowPosX === focusedPos.x && entry.windowPosY === focusedPos.y;
    });

    if (!skill) {
      throw new Error("Trying to learn a focused skill that does not exist.");
    }

    if (!skill.model.isEnabled) return false; // skill is deactivated

    if (skill.level !== 0) return false; // skill already learned

    if (skillPoints < 1) return false; // not enough points

    return true;
  }, [focusedPos, classSkills, currentPage, skillPoints]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_SkillsWindowModule.default.window, _SkillsWindowModule.default[currentTab], className),
    style: style
  }, /*#__PURE__*/_react.default.createElement(_WindowControls.default, {
    classNameDragHandler: _SkillsWindowModule.default.dragHandler,
    classNameCloseBtn: _SkillsWindowModule.default.closeBtn
  }), /*#__PURE__*/_react.default.createElement(_TabButtons.default, {
    className: _SkillsWindowModule.default.tabButtons,
    currentTab: currentTab,
    onChangeTab: changeTab
  }), /*#__PURE__*/_react.default.createElement(_Page.default, {
    className: _SkillsWindowModule.default.skillsPage,
    entries: entries,
    entityType: currentTab,
    focusedPos: focusedPos,
    onClickEntry: handleOnClickEntry
  }), currentTab !== "CRAFTING" && /*#__PURE__*/_react.default.createElement(_PageButtons.default, {
    className: _SkillsWindowModule.default.pageButtons,
    currentPage: currentPage,
    onChangePage: changePage
  }), /*#__PURE__*/_react.default.createElement(_Footer.default, {
    className: _SkillsWindowModule.default.footer,
    availableSkillPoints: skillPoints,
    onClickSkillUp: handleOnClickSkillUp,
    hideSkillUpButton: currentTab === "COMBOS"
  }));
}